// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"ea-z","fullWidth":"fa-z","heading":"ga-z","screenReadersOnly":"ha-z"};